import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const o = (l) => /* @__PURE__ */ e(
  "svg",
  {
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(l),
    children: [
      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_3840_25243)", children: /* @__PURE__ */ C(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3034 0.77079C9.16324 0.896838 6.99695 1.69076 5.29139 2.97413C2.82035 4.83353 1.24867 7.52122 0.851082 10.5674C0.707154 11.67 0.742074 12.9337 0.947658 14.064C1.21132 15.5135 1.82673 17.0194 2.66416 18.264C4.38383 20.8199 7.0696 22.5663 10.0794 23.0856C11.3448 23.304 12.678 23.304 13.9434 23.0856C16.1039 22.7128 18.1231 21.7009 19.7244 20.1884C21.6521 18.3677 22.8476 16.0079 23.1822 13.3631C23.3098 12.3552 23.2777 11.1152 23.097 10.068C22.6851 7.68051 21.4922 5.47018 19.7159 3.80273C17.4371 1.66354 14.4464 0.585702 11.3034 0.77079ZM11.3754 2.27101C9.66216 2.40735 8.17694 2.89388 6.77939 3.77657C5.62111 4.50817 4.51955 5.60972 3.78796 6.76801C2.98367 8.04142 2.51191 9.3787 2.32324 10.92C2.26319 11.4105 2.26319 12.5895 2.32324 13.08C2.51191 14.6213 2.98367 15.9586 3.78796 17.232C4.51955 18.3903 5.62111 19.4918 6.77939 20.2234C8.05096 21.0266 9.39477 21.5006 10.9314 21.6883C11.4222 21.7482 12.6015 21.7481 13.0914 21.6882C14.629 21.5 15.973 21.0258 17.2434 20.2234C18.4017 19.4918 19.5032 18.3903 20.2348 17.232C21.0372 15.9616 21.5113 14.6176 21.6995 13.08C21.7595 12.5901 21.7596 11.4108 21.6997 10.92C21.512 9.38338 21.0379 8.03957 20.2348 6.76801C19.5032 5.60972 18.4017 4.50817 17.2434 3.77657C15.9792 2.97812 14.6198 2.49687 13.1154 2.31529C12.8059 2.27792 11.6561 2.24866 11.3754 2.27101ZM11.8715 7.51549C11.6344 7.55381 11.4349 7.7144 11.3243 7.95605L11.2683 8.07829L11.2669 10.1224L11.2654 12.1665L11.318 12.2932C11.3645 12.4054 11.6479 12.698 13.773 14.8285C15.0959 16.1548 16.2303 17.2728 16.2975 17.3167C16.789 17.6377 17.4389 17.285 17.4418 16.6958C17.4434 16.3505 17.6 16.5286 15.0436 13.9676L12.7554 11.6752L12.7552 9.8756L12.7549 8.07601L12.6983 7.95445C12.6266 7.80034 12.5176 7.6759 12.3877 7.59977C12.2978 7.54712 12.2433 7.53147 12.0474 7.50202C12.021 7.49806 11.9419 7.50411 11.8715 7.51549Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_3840_25243", children: /* @__PURE__ */ C(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.0117188)"
        }
      ) }) })
    ]
  }
);
export {
  o as ClockIcon
};
//# sourceMappingURL=ClockIcon.js.map
